import { render, staticRenderFns } from "./ActionsView.vue?vue&type=template&id=396ff95c"
import script from "./ActionsView.vue?vue&type=script&lang=js"
export * from "./ActionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports